export let leaderboard;

WL.registerComponent('leaderboard', {
  }, {
    init: function () {
        this.data = {};
        leaderboard = this;
        let children = this.object.children;

        for (let i = 0; i < children.length; i++) {
            const container = children[i];
            if(container.name === "TableContent") {
                const textElements = container.children;
                for (let j = 0; j < textElements.length; j++) {
                    const element = textElements[j];
                    switch(element.name) {
                        case "PlayerNames":
                            this.playerNamesList = element.getComponent('text');
                             break;
                        case "Kills":
                            this.killsList = element.getComponent('text');
                            break;
                        case "Deaths":
                            this.deathsList = element.getComponent('text');
                            break;
                    }
                }
            }
        }
        this.displayData();
    },
    addPlayer: function(player) {
        this.data[player] = {
            kills: 0,
            deaths: 0,
        }
        this.displayData();
    },
    removePlayer: function(player) {
        delete this.data[player];
        this.displayData();
    },
    updateData: function(player, isKills, value) {
        this.data[player][isKills ? "kills" : "deaths"] = value;
        this.displayData();
    },
    displayData: function() {
        let players = Object.keys(this.data);
        players.sort((a,b) => this.data[b].kills - this.data[a].kills)
        let namesString = '';
        let killsString = '';
        let deathsString = '';
        
        for (let index = 0; index < players.length; index++) {
            const playerName = players[index];
            namesString += playerName + '\n';
            killsString += this.data[playerName].kills + '\n';
            deathsString += this.data[playerName].deaths + '\n';
        }

        this.playerNamesList.text = namesString;
        this.killsList.text = killsString;
        this.deathsList.text = deathsString;
    }
  });
  